import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Psychology as PsychologyIcon } from '@mui/icons-material';
import { askNara } from './naraChatContext';

/**
 * Small contextual button that opens NaraChat with a pre-filled question.
 *
 * Usage:
 *   <AskNara question="Resume el expediente de este paciente" />
 *   <AskNara question="Interpreta estos resultados de laboratorio" label="Analizar con NARA" />
 */
const AskNara = ({ question, label, size = 'small', sx = {} }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    askNara(question);
  };

  return (
    <Tooltip title={label || 'Preguntar a NARA'} placement="top">
      <IconButton
        size={size}
        onClick={handleClick}
        sx={{
          width: 26, height: 26,
          background: 'linear-gradient(135deg, rgba(16,185,129,0.15), rgba(5,150,105,0.15))',
          border: '1px solid rgba(16,185,129,0.25)',
          transition: 'all 0.2s',
          '&:hover': {
            background: 'linear-gradient(135deg, rgba(16,185,129,0.3), rgba(5,150,105,0.3))',
            transform: 'scale(1.1)',
            boxShadow: '0 2px 12px rgba(16,185,129,0.3)',
          },
          '&:active': { transform: 'scale(0.95)' },
          ...sx,
        }}
      >
        <PsychologyIcon sx={{ fontSize: 14, color: '#10b981' }} />
      </IconButton>
    </Tooltip>
  );
};

export default AskNara;
